// Persistent AI disclosure indicator shown inside DM and FateGram character interaction areas.
// Required by NY AI Companion Models Law (Nov 2025) and CA SB 243 (Jan 2026).
export default function AIDisclosureBanner({ characterName, compact = false }) {
  if (compact) {
    return (
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '3px 8px',
        background: 'rgba(196,168,130,0.08)',
        border: '1px solid rgba(196,168,130,0.2)',
        borderRadius: '20px',
        fontSize: '11px',
        color: '#8a7a65',
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        letterSpacing: '0.5px',
        cursor: 'pointer',
        userSelect: 'none',
      }}
        onClick={() => window.location.href = '/ai-disclosure'}
        title="This character is AI-generated. Tap to learn more."
      >
        <span style={{ fontSize: '10px' }}>🤖</span>
        <span>AI</span>
      </div>
    );
  }

  return (
    <div style={{
      background: 'rgba(196,168,130,0.06)',
      borderBottom: '1px solid rgba(196,168,130,0.1)',
      padding: '6px 14px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      fontSize: '11px',
      color: '#6a5f4f',
      fontFamily: "'Cormorant Garamond', Georgia, serif",
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', minWidth: 0 }}>
        <span style={{ flexShrink: 0 }}>🤖</span>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {characterName ? `${characterName} is an AI character` : 'This is an AI character'} — not a real person
        </span>
      </div>
      <a
        href="/ai-disclosure"
        style={{
          color: '#8a7a65',
          textDecoration: 'underline',
          textUnderlineOffset: '2px',
          flexShrink: 0,
          fontSize: '11px',
        }}
      >
        Learn more
      </a>
    </div>
  );
}
